import conn from "@/store/utils/connection";
import transaksiAPI from "@/store/utils/api-route/transaksiAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"
import whitelabelApi from "@/store/utils/api-route/whitelabelApi";

const actions = {
	queryFilterTransaksi({commit, rootGetters}, idkonsumen) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

		let query = {
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset
		}
		if (idkonsumen !== "") {
			query.idkonsumen = idkonsumen
		}
		// periode
		if (getFilterItem.periode.filterBy !== "") {
			query.filter_by = getFilterItem.periode.filterBy

			switch (getFilterItem.periode.filterBy) {
				case "periode":
					query.tanggal_awal = getFilterItem.periode.startDate
					query.tanggal_akhir = getFilterItem.periode.endDate
					break;
				case "bulan":
					query.bulan = getFilterItem.periode.month
					break;
				case "tahun":
					query.tahun = getFilterItem.periode.year
					break;
				default:
					break;
			}
		}
		// jenis transaksi
		if (getFilterItem.jenisTransaksi.length > 0) {
			query.jenis_transaksi_array = getFilterItem.jenisTransaksi
		}
		// jenis transaksi dengan pembayaran
		if (getFilterItem.tipePembayaran.length > 0) {
			query.status_pembayaran = getFilterItem.tipePembayaran
		}
		// jenis pembayaran
		if (getFilterItem.jenisPembayaran.length > 0) {
			query.jenis_pembayaran = getFilterItem.jenisPembayaran
		}
		// jenis pembayaran akun debit
		if (getFilterItem.jenisPembayaranAkunDebit !== "") {
			query.idakundebit = getFilterItem.jenisPembayaranAkunDebit
		}
		// jenis pembayaran akun EDC
		if (getFilterItem.jenisPembayaranAkunEDC !== "") {
			query.idakunedc = getFilterItem.jenisPembayaranAkunEDC
		}
		// outlet
		if (getFilterItem.outlet.length > 0) {
			query.outlet_array = getFilterItem.outlet
		}
		// status bayar
		if (getFilterItem.statusPembayaran.length > 0) {
			query.status_bayar_array = getFilterItem.statusPembayaran
		}
		// status transaksi
		if (getFilterItem.statusTransaksi.length > 0) {
			query.status_transaksi_array = getFilterItem.statusTransaksi
		}
		// tahapan
		if (getFilterItem.tahapan.length > 0) {
			query.tahapan_pengerjaan_array = getFilterItem.tahapan
		}
		// pembuat nota
		if (getFilterItem.karyawan !== "") {
			query.karyawan = [getFilterItem.karyawan]
		}
		// mesin yang digunakan
		if (getFilterItem.mesinSnap !== "") {
			query.idmesin = [getFilterItem.mesinSnap]
		}
		// layanan
		if (getFilterItem.layananOwner.length > 0) {
			query.layanan = getFilterItem.layananOwner
		}

		// filter kolom
		if (getFilterItem.filterKolomTransaksi !== "") {
			query.filter_kolom = getFilterItem.filterKolomTransaksi
		}
		// search
		if (state.isSearch) {
			query.key = state.search.key
		}

		//idpromo
		if (getFilterItem.idpromo != "") {
			query.idpromo = getFilterItem.idpromo
		}

		return query
	},

	async fetchListTransaksiKonsumen({commit, dispatch}, id) {
		try {
			let query = await dispatch("queryFilterTransaksi", id)
			const res = await conn.get(transaksiAPI.customer.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				// let objQuery = conn.queryStringToObject(query)
				// let compareObjQuery = conn.queryStringToObject(window.location.search)
				// if (JSON.stringify(objQuery) !== JSON.stringify(compareObjQuery)) {
				// 	await router.replace({query: objQuery})
				// }
				// router.replace({query: query})
				await conn.setQueryString(query)
				// commit("setQueryListTransaksi", objQuery)
				commit("setListTransaksiKonsumen", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchInfoTransaksiKonsumen({commit, dispatch}, id) {
		try {
			let query = await dispatch("queryFilterTransaksi", id)
			const res = await conn.get(transaksiAPI.customer.info, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setInfoTransaksiKonsumen", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailTransaksi({commit}, id) {
		try {
			// let query = "idtransaksi=" + id
			let query = {idtransaksi: id}
			const res = await conn.get(transaksiAPI.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailTransaksi", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailLayananTransaksi({commit}, payload) {
		try {
			let query = {
				idtransaksi: payload.idtransaksi,
				iddetlayanan: payload.iddetlayanan,
			}
			const res = await conn.get(transaksiAPI.detailLayanan, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailLayananTransaksi", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchStatusTransaksi({commit}, id) {
		try {
			// let query = "idtransaksi=" + id
			let query = {idtransaksi: id}
			const res = await conn.get(transaksiAPI.status, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setStatusTransaksi", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchStatusTransaksiWhitelabel({commit}, id) {
		try {
			// let query = "idtransaksi=" + id
			const res = await conn.get(whitelabelApi.statusTransaksi(id))
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailDataPengantaranExtra({commit}, id) {
		try {
			// let query = "idantarextra=" + id
			let query = {idantarextra: id}
			const res = await conn.get(transaksiAPI.detail_pengantaran_extra, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailPengantaranExtra", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async deleteTransaksi({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idtransaksi", payload.id)
			if (payload.keterangan !== "") form.append("keterangan", payload.keterangan)
			const res = await conn.post(transaksiAPI.hapus.transaksi, form, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async deleteTransaksiV2({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idtransaksi", payload.id)
			if (payload.keterangan !== "") form.append("keterangan", payload.keterangan)
			form.append("data_refund_json", payload.dataRefund)
			payload.voidData.forEach(v => {
				v.file.forEach(file => {
					form.append("bukti_void_" + v.idbayar + "[]", file)
				})
			})
			const res = await conn.post(transaksiAPI.hapus.transaksiV2, form, conn.contentType.multipart)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return res.data.status ? resulter.successResult(res.data.msg) : resulter.errorResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async setujuiPermintaanHapus({commit}, payload) {
		try {
			let form = new FormData()
			form.append("idpermintaanhapus", payload.idpermintaan_hapus)
			form.append("idtransaksi", payload.id)
			if (payload.keterangan !== "") form.append("keterangan_status", payload.keterangan)
			form.append("data_refund_json", payload.dataRefund)
			payload.voidData.forEach(v => {
				v.file.forEach(file => {
					form.append("bukti_void_" + v.idbayar + "[]", file)
				})
			})
			const res = await conn.post(transaksiAPI.permintaanHapus, form, conn.contentType.multipart)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async deletePengantaranExtra({commit}, id) {
		try {
			let form = new FormData()
			form.append("idantarextra", id)
			const res = await conn.post(transaksiAPI.hapus.pengantaran_extra, form, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async export({commit, dispatch}, payload) {
		try {
			let query = await dispatch("queryFilterTransaksi", payload.id)
			let formData = new FormData
			formData.append("type", payload.type)
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(transaksiAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				let keyExport = await dispatch("keyExport", payload.type)
				localStorage.setItem("key_export_transaksi", keyExport)
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	keyExport({commit}, type) {
		let key = ""
		switch (type) {
			case "transaksi_reguler_export":
				key = "export:job:transaksi:reguler"
				break;
			case "rak_transaksi_export":
				key = "export:job:transaksi:rak"
				break;
			case "pengerjaan_transaksi_export":
				key = "export:job:transaksi:pengerjaan"
				break;
			case "pembayaran_transaksi_export":
				key = "export:job:transaksi:pembayaran"
				break;
			default:
				break;
		}
		return key
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_transaksi")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport,
			}
			const res = await conn.get(transaksiAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(transaksiAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		// localStorage.removeItem("key_export_transaksi")
		try {
			let keyExport = localStorage.getItem("key_export_transaksi")
			let query = {
				key: keyExport
			}
			const res = await conn.get(transaksiAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_transaksi")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions